export const toastTokens = {
  'toast-bg': 'var(--dp-color-background)',
  'toast-border-radius': 'var(--dp-border-radius-md)',
  'toast-shadow': 'var(--dp-shadow-lg)',
  'toast-padding': 'var(--dp-spacing-md)',
  'toast-min-width': '280px',
  'toast-max-width': '420px',
  'toast-z-index': '9999',
  'toast-gap': 'var(--dp-spacing-sm)',
  'toast-close-color': 'var(--dp-color-text-tertiary)',
  'toast-duration': '5000ms',
} as const;
